// src/context/ApplicationContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

// Create Context
const ApplicationContext = createContext();

// Provider Component
export const ApplicationProvider = ({ children }) => {
  const [applications, setApplications] = useState([]);
  const { isAuthenticated, authVersion } = useAuth();

  // Fetch Applications from API
  const fetchApplications = async () => {
    try {
      const response = await api.get("/Applications");
      setApplications(response.data || []);
    } catch (error) {}
  };

  // Add Application
  const addApplication = async (newApplication) => {
    try {
      const res = await api.post("/Applications", newApplication);
      setApplications((prev) => [...prev, res.data]);
    } catch (error) {}
  };

  // Update Application
  const updateApplication = async (id, updatedApplication) => {
    try {
      const res = await api.put(`/Applications/${id}`, updatedApplication);
      setApplications((prev) =>
        prev.map((r) => (r.ApplicationId === id ? res.data : r))
      );
    } catch (error) {}
  };

  // Delete Application
  const deleteApplication = async (id) => {
    try {
      await api.delete(`/Applications/${id}`);
      setApplications((prev) => prev.filter((r) => r.ApplicationId !== id));
    } catch (error) {}
  };

  // Note: Auto-fetch removed to prevent race condition with organization sync.
  // Components should fetch applications after useOrganizationSync confirms isReady.

  return (
    <ApplicationContext.Provider
      value={{
        applications,
        addApplication,
        updateApplication,
        deleteApplication,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

// ✅ Custom hooks
export const useApplications = () => {
  const { applications } = useContext(ApplicationContext);
  return applications;
};

export const useApplicationActions = () => {
  const { addApplication, updateApplication, deleteApplication } =
    useContext(ApplicationContext);
  return { addApplication, updateApplication, deleteApplication };
};
